import _ from 'lodash';
import { getRequest } from '../../Common/network-call';
import { INSTANCE_URL } from '../../Common/constant';
import LocalStrings from '../../../languages';

export const FETCH_ALL_EVENT_MAPS = 'FETCH_ALL_EVENT_MAPS';
export const SET_MAP_DETAILS = 'SET_MAP_DETAILS';

export const fetchEventMaps = (session, callback) => {
  var mapsArr = [];
  var filter = encodeURI(`(eventid=${session.eventid})`);
  var interactiveUrl = `${INSTANCE_URL}/api/v2/eventify/_table/interactivemaps?include_count=true&filter=${filter}`;
  var locationUrl = `${INSTANCE_URL}/api/v2/eventify/_table/locationmaps?include_count=true&filter=${filter}`;

  return dispatch => {
    getRequest(
      interactiveUrl,
      session,
      dispatch,
      resInter => {
        if (resInter.meta.count > 0) {
          mapsArr = _.orderBy(resInter.resource, 'displayorder', 'asc');
          getRequest(
            locationUrl,
            session,
            dispatch,
            resLoc => {
              if (resLoc.meta.count > 0) {
                var arr = _.orderBy(resLoc.resource, 'displayorder', 'asc');
                mapsArr = _.concat(mapsArr, arr);
                mapsArr = _.orderBy(mapsArr, 'displayorder', 'asc');
              }

              dispatch({
                type: FETCH_ALL_EVENT_MAPS,
                payload: {
                  data: mapsArr,
                  count: resInter.meta.count + resLoc.meta.count
                }
              });
              callback({
                success: 1,
                data: mapsArr,
                count: resInter.meta.count + resLoc.meta.count
              });
            },
            errorLoc => {
              callback({ success: 0, message: errorLoc });
            }
          );
        } else {
          getRequest(
            locationUrl,
            session,
            dispatch,
            resLoc => {
              if (resLoc.meta.count > 0) {
                mapsArr = _.orderBy(resLoc.resource, 'displayorder', 'asc');
              }
              dispatch({
                type: FETCH_ALL_EVENT_MAPS,
                payload: { data: mapsArr, count: resLoc.meta.count }
              });
              callback({ success: 1, data: mapsArr, count: resLoc.meta.count });
            },
            errorLoc => {
              callback({ success: 0, message: errorLoc });
            }
          );
        }
      },
      errorInter => {
        callback({ success: 0, message: errorInter });
      }
    );
  };
};

export const clearEventMaps = () => {
  return dispatch => {
    dispatch({ type: FETCH_ALL_EVENT_MAPS, payload: {} });
  };
};

export const setMapDetails = value => {
  return dispatch => {
    dispatch({ type: SET_MAP_DETAILS, payload: value });
  };
};

export const clearMapDetails = () => {
  return dispatch => {
    dispatch({ type: SET_MAP_DETAILS, payload: {} });
  };
};

export const fetchInteractiveMapDetails = (session, mapId, callback) => {
  let related = `interactivemap_locations_by_interactivemapid,interactivemap_locations_by_interactivemaplocation_exhibitor_link,exhibitors_by_interactivemaplocation_exhibitor_link,interactivemaplocation_exhibitor_link_by_interactivemapid,session_by_interactivemaplocation_session_link,interactivemaplocation_session_link_by_interactivemapid,speaker_by_interactivemaplocation_speaker_link,interactivemaplocation_speaker_link_by_interactivemapid,sponsor_by_interactivemaplocation_sponsor_link,interactivemaplocation_sponsor_link_by_interactivemapid`;
  let filter = encodeURI(
    `(eventid=${session.eventid})AND(interactivemapid=${mapId})`
  );
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/interactivemaps?related=${related}&filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      res => {
        callback({ success: 1, data: res.resource[0] });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};
